"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferFullnessExit_1 = require("./Constants/BufferFullnessExit");
var State_1 = require("./Constants/State");
var updateVariantSteady_1 = require("./updateVariantSteady");
function createStateSteady() {
    return {
        label: State_1.default.STEADY,
        entry: function (params) {
            var abrState = params.abrState, metrics = params.metrics, callbacks = params.callbacks;
            callbacks.setTimeoutFirstByte(2000);
            callbacks.setTimeoutLoad(6000);
            var setCurrentVariantIndex = callbacks.setCurrentVariantIndex;
            updateVariantSteady_1.default({
                abrState: abrState,
                metrics: metrics,
                setCurrentVariantIndex: setCurrentVariantIndex
            });
        },
        update: function (params) {
            var abrState = params.abrState, metrics = params.metrics, callbacks = params.callbacks;
            var bufferDepth = metrics.bufferedDuration.min;
            if (bufferDepth < BufferFullnessExit_1.default.STEADY_TO_PANICMODE) {
                callbacks.setState(State_1.default.PANICMODE);
            }
            else {
                var setCurrentVariantIndex = callbacks.setCurrentVariantIndex;
                updateVariantSteady_1.default({
                    abrState: abrState,
                    metrics: metrics,
                    setCurrentVariantIndex: setCurrentVariantIndex
                });
            }
        }
    };
}
exports.default = createStateSteady;
//# sourceMappingURL=createStateSteady.js.map